import { BrandLineUI } from "./BrandLineUI";
import { getOwnBrand } from "../../utils/product/getOwnBrand";
import { StandardProps } from "../componentMap";

export function BrandLine({ product }: Pick<StandardProps, "product">) {
  const ownBrand = getOwnBrand(product);

  return <BrandLineUI ownBrand={ownBrand} />;
}
